module.exports = __webpack_public_path__ + "static/caisterroofing-web-b30303511d7e2b453f00b7c1b2412ce9.jpg";